import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import AppointmentReminderSettings from '../components/AppointmentReminderSettings';

const ReminderSettings = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" gutterBottom>
          Reminder Settings
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Configure your appointment reminder preferences
        </Typography>
      </Box>
      
      <AppointmentReminderSettings />
    </Container>
  );
};

export default ReminderSettings;